export enum ProcessStatus {
  InProgress = 'IN PROGRESS',
  Completed = 'COMPLETED',
}
